import type { TrustGroupUserDto } from "@/models/dto/trustGroupUserDto";
import axios from "axios";
import type { TrustGroup } from "@/models/trustGroup";

export const getIsCustomer = async (): Promise<boolean> => {
  const response = await axios.get("/api/trust-group/is-customer");
  return response.data;
};

export const addUserToTrustGroup = async (
  user: TrustGroupUserDto
): Promise<void> => {
  await axios.post("/api/trust-group/add-user", user);
};

export const removeUserFromTrustGroup = async (user: TrustGroupUserDto): Promise<void> => {
  await axios.put("/api/trust-group/remove-user", user);
}

export const getTrustGroupUsers = async (): Promise<TrustGroupUserDto[]> => {
  const response = await axios.get("/api/trust-group/users");
  return response.data;
};

export const getTrustGroupOnSession = async (): Promise<TrustGroup> => {
  const response = await axios.get("/api/trust-group");
  return response.data;
};